export default {
  title: 'Importuj {type}',
};
